import { useEffect } from "react";

/**
 * Phase 13.5 — set `document.title` per-route.
 *
 * The IA review (DECISIONS.md 2026-05-09) extracted FIRE sub-pages out
 * of `/dashboard#anchor` hash-anchors into real routes — each "deserves
 * its own browser title". This hook is the smallest possible primitive
 * for that: useEffect sets `document.title`; restores on unmount so the
 * previous page's title comes back when transient overlays / modals
 * mount.
 *
 * Title format: "<page> · Hearth" — page label first so it's visible in
 * tab strips that truncate from the right.
 */
const SUFFIX = "Hearth";

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const prior = document.title;
    document.title = title.length > 0 ? `${title} · ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = prior;
    };
  }, [title]);
}
